import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import AuthService from "services/auth.service";
import { Row, Col, Input} from "reactstrap";

const User = props => {
  const { id }= useParams();
  let navigate = useNavigate();

  const initialTransactionState = {        
    title: "",
    totalFee: "",
    refundableFee: "",
    paymentMethod: "",
    description: "",
    createdAt: "",    
  };
  
  const [currentTransaction, setCurrentTransaction] = useState(initialTransactionState);
  const [message, setMessage] = useState("");
  const [date, setDate] = useState(""); 

  const getTransaction = id => {
    AuthService.getTransactionById(id)
      .then(response => {
        setCurrentTransaction(response.data);

         const formattedDate = response.data.createdAt 
        ? new Date(response.data.createdAt).toISOString().split('T')[0]
        : "";
        setDate(formattedDate);
        //console.log(response.data);
      })
      .catch(e => {
        //console.log(e);
      });
  };

  useEffect(() => {
    if (id) getTransaction(id);
  }, [id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentTransaction({ ...currentTransaction, [name]: value });
  };

  const onChangeDate = (e) => {
    setDate(e.target.value);
  };
  

  const updateStatus = boo => {
    const data = {      
      title: currentTransaction.title,
      description: currentTransaction.description,
      status: boo,
      paymentMethod: currentTransaction.paymentMethod,
      createdAt: date,      
    };

    AuthService.updateTransaction(currentTransaction.id, data)
      .then(response => {
        setCurrentTransaction({ ...currentTransaction, status: boo });
        //console.log(response.data);
      })
      .catch(e => {
        //console.log(e);
      });
  };

  const updateTransac = () => {
    const updatedTransaction = {
      ...currentTransaction,
      createdAt: date,
    };

    AuthService.updateTransaction(currentTransaction.id, updatedTransaction)
      .then(response => {
        //console.log(response.data);
        setMessage("The Transaction was updated successfully!");
        
      })
      .catch(e => {
        //console.log(e);
      });
  };

  const deleteTransaction = () => {
    AuthService.removeTransaction(currentTransaction.id)
      .then(response => {
        //(response.data);
        navigate("/admin/transactions");
      })
      .catch(e => {
        //console.log(e);
      });
  };

  return (
    <div className="content">
        <Row>
          <Col>
      {currentTransaction ? (
        <div className="edit-form">
          <h4>Transaction update</h4>
          <form>
            
            <div className="form-group">
                <label htmlFor="title">Title</label>
                <Input
                  type="text"
                  className="form-control"
                  name="title"
                  value={currentTransaction.title}
                  onChange={handleInputChange}
                //   validations={[required, validEmail]}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="totalFee"> Total Fee</label>
                <Input
                  type="text"
                  className="form-control"
                  name="totalFee"
                  value={currentTransaction.totalFee}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                      <label htmlFor="paymentMethod">Payment Method</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="paymentMethod"
                        value={currentTransaction.paymentMethod}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="description">Description</label>
                      <Input
                        type="text"
                        className="form-control"
                        name="description"
                        value={currentTransaction.description}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="date">Date {}</label>
                      <Input
                        type="date"
                        className="form-control"
                        name="createdAt"
                        value={date}
                        onChange={onChangeDate}
                      />
                    </div>
              {/* <div className="form-group">
                <label htmlFor="refundableFee">Refundable Fee</label>
                <Input
                  type="text"
                  className="form-control"
                  name="refundableFee"
                  value={currentTransaction.refundableFee}
                  onChange={handleInputChange}
                  required
                />
              </div> */}
              
            <div className="form-group">
              <label>
                <strong>Status:</strong>
              </label>
              {currentTransaction.status ? "Paid" : "Pending"}
            </div>
          </form>

          {currentTransaction.status ? (
            <button
              className="badge badge-primary mr-2"
              onClick={() => updateStatus(false)}
            >
              UnPaid
            </button>
          ) : (
            <button
              className="badge badge-primary mr-2"
              onClick={() => updateStatus(true)}
            >
              Paid
            </button>
          )}

          <button className="badge badge-danger mr-2" onClick={deleteTransaction}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateTransac}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on a transaction...</p>
        </div>
      )}
    
    </Col>
    </Row>
    </div>
    
  );
};

export default User;